import styled from 'styled-components';
import { useElements, useScene } from '../../../hooks';

import { updateObjectNestedProperties } from '../../../functions/objectFunctions/updateObjectNestedProperties';
import {
  LauncherElement,
  LauncherElementTypeName,
} from '../../../types/launcherElement';
import { commandOptions, variableOptions } from '../../../types/options';
import { TextInput } from '../../common/inputs/TextInput';
import { SelectInput } from '../../common/inputs/selectInput/SelectInput';

export const DataProps = () => {
  const scene = useScene();
  const lastSelectedElementID = scene.selectedElementIDs.slice(-1)[0];
  const [selectedElement, setSelectedElement] = useElements<LauncherElement>({
    id: lastSelectedElementID,
  });

  const renderProps = (elementType: LauncherElementTypeName) => {
    switch (elementType) {
      case 'button':
        return (
          <Container>
            <SelectInput
              label="Command"
              id={`${lastSelectedElementID}-command-input`}
              options={commandOptions}
              value={selectedElement.props.command?.type}
              onChange={(inputValue: string) => {
                setSelectedElement((prev) =>
                  updateObjectNestedProperties(prev, {
                    'props.command': inputValue,
                  })
                );
              }}
            />
            {selectedElement.props.command?.type ===
              'open-external-link-command' && (
              <TextInput
                label="URL"
                id={`${lastSelectedElementID}-command-url-input`}
                value={selectedElement.props.command?.linkUrl}
                onChange={(inputValue: string) => {
                  setSelectedElement((prev) =>
                    updateObjectNestedProperties(prev, {
                      'props.command.linkUrl': inputValue,
                    })
                  );
                }}
              />
            )}
          </Container>
        );
      case 'text':
        return (
          <Container>
            <TextInput
              label="Text"
              id={`${lastSelectedElementID}-text-input`}
              value={selectedElement.props.text}
              onChange={(inputValue: string) => {
                setSelectedElement((prev) =>
                  updateObjectNestedProperties(prev, {
                    'props.text': inputValue,
                  })
                );
              }}
            />
          </Container>
        );
      case 'variableText':
        return (
          <Container>
            <SelectInput
              label="Variable"
              id={`${lastSelectedElementID}-variable-input`}
              options={variableOptions}
              value={selectedElement.props.variable}
              onChange={(inputValue: string) => {
                setSelectedElement((prev) =>
                  updateObjectNestedProperties(prev, {
                    'props.variable': inputValue,
                  })
                );

                // To update handle size
                scene.setSelectedElementIDs((prev) => [...prev]);
              }}
            />
          </Container>
        );
      case 'link':
        return (
          <Container>
            <TextInput
              label="Text"
              id={`${lastSelectedElementID}-text-input`}
              value={selectedElement.props.text}
              onChange={(inputValue: string) => {
                setSelectedElement((prev) =>
                  updateObjectNestedProperties(prev, {
                    'props.text': inputValue,
                  })
                );
              }}
            />
            <TextInput
              label="URL"
              id={`${lastSelectedElementID}-href-input`}
              value={selectedElement.props.href}
              onChange={(inputValue: string) => {
                setSelectedElement((prev) =>
                  updateObjectNestedProperties(prev, {
                    'props.href': inputValue,
                  })
                );
              }}
            />
          </Container>
        );
      case 'img':
        return (
          <Container>
            <TextInput
              label="Image URL"
              id={`${lastSelectedElementID}-img-src-input`}
              value={selectedElement.props.src}
              onChange={(inputValue: string) => {
                setSelectedElement((prev) =>
                  updateObjectNestedProperties(prev, {
                    'props.src': inputValue,
                  })
                );
              }}
            />
          </Container>
        );
      case 'iframe':
        return (
          <Container>
            <TextInput
              label="URL"
              id={`${lastSelectedElementID}-iframe-src-input`}
              value={selectedElement.props.src}
              onChange={(inputValue: string) => {
                setSelectedElement((prev) =>
                  updateObjectNestedProperties(prev, {
                    'props.src': inputValue,
                  })
                );
              }}
            />
          </Container>
        );
    }

    return <></>;
  };

  return renderProps(selectedElement?.type);
};

const Container = styled.div`
  margin: 20px 0;

  display: flex;
  flex-direction: column;
  gap: 5px;
`;
